import SectionHeader from '@/components/base/SectionHeader';

const faqs = [
  {
    q: '在布丁漫画网阅读漫画需要付费吗？',
    a: '完全免费。布丁漫画网坚持全站免费在线阅读，《寄宿日记》等所有作品均无需付费、无需注册即可畅读全集中文版本。',
  },
  {
    q: '《寄宿日记》漫画多久更新一次？',
    a: '《寄宿日记》每周固定更新，通常在周五晚更新新章节，遇节假日会加更。您可以在作品页查看最近更新时间。',
  },
  {
    q: '手机和电脑都能看漫画吗？',
    a: '可以。布丁漫画网采用响应式设计，手机、平板、电脑浏览器均可直接访问，无需下载任何应用即可流畅阅读。',
  },
  {
    q: '遇到漫画页面加载失败怎么办？',
    a: '建议先刷新页面或切换网络环境重试；若仍无法加载，可联系官方邮箱 contact@pudingmh.com，我们会在 24 小时内处理。',
  },
  {
    q: '如何快速找到想看的漫画？',
    a: '您可以通过顶部搜索框直接输入漫画名称，也可以进入"全部漫画"页面按恋爱、校园、日常等分类浏览，或参考热门排行榜选择。',
  },
];

export default function HomeFaq() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeader title="常见问题" subtitle="阅读前的小疑问，这里都有答案" />
        <div className="flex flex-col gap-3">
          {faqs.map((item) => (
            <details
              key={item.q}
              className="group rounded-xl bg-background-50 p-4 transition-colors open:bg-background-50 md:p-5"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-sm font-medium text-foreground-900 md:text-base">
                {item.q}
                <i className="ri-add-line shrink-0 text-lg text-primary-500 transition-transform group-open:rotate-45"></i>
              </summary>
              <p className="mt-3 text-sm leading-6 text-foreground-600">
                {item.a}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}